export default __webpack_public_path__ + "static/outsource@768_2x-70128b7be018638f133040aaa7bdb4f9.webp";